import { render } from "./ThirdPartyLogin.vue?vue&type=template&id=2b1eec4f"
import script from "./ThirdPartyLogin.vue?vue&type=script&lang=js"
export * from "./ThirdPartyLogin.vue?vue&type=script&lang=js"

import "./ThirdPartyLogin.vue?vue&type=style&index=0&id=2b1eec4f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__